import template from './eventInfo.html';
import controller from './eventInfo.controller';
import '../../constants';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    event: '<',
    recapResponse: '<'
  },
};

export default component;
